import React, { useState } from "react";
import Select from "react-select";
import {
  useGetAllPartnerCategoriesQuery,
  useGetPartnerCategoryByIdQuery,
} from "src/store/services/partnerApi";

type Props = {
  formData: {
    outlets: string[];
  };
  onInputChange: (e: any) => void;
};

const CentralPartnerBasicInfoForm: React.FC<Props> = ({
  formData,
  onInputChange,
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string>("");

  // ======================
  // FETCH CATEGORIES
  // ======================
  const { data: categoriesData, isLoading: categoryLoading } =
    useGetAllPartnerCategoriesQuery();

  // ======================
  // FETCH OUTLETS BY CATEGORY
  // ======================
  const { data: partnersData, isLoading: partnersLoading } =
    useGetPartnerCategoryByIdQuery(
      { page: 1, id: selectedCategory, limit: 1000 },
      { skip: !selectedCategory }
    );

  // ======================
  // CATEGORY OPTIONS
  // ======================
  const categoryOptions =
    categoriesData?.payload?.data?.map((cat: any) => ({
      value: cat.category_id,
      label: cat.category_name,
    })) || [];

  // ======================
  // OUTLET OPTIONS (CURRENT CATEGORY)
  // ======================
  const partnerOptions =
    partnersData?.payload?.partners?.map((p: any) => ({
      value: p._id || p.partner_id || p.id,
      label: p.business_name || p.name || "Unnamed Outlet",
    })) || [];

  // ======================
  // HANDLE MULTI OUTLET SELECT
  // ======================
  const handleOutletChange = (options: any) => {
    const newValues = options
      ? options.map((opt: any) => opt.value)
      : [];

    // ✅ merge with existing outlets (avoid duplicates)
    const merged = Array.from(
      new Set([...(formData.outlets || []), ...newValues])
    );

    onInputChange({
      target: {
        name: "outlets",
        value: merged,
      },
    });
  };

  return (
    <div className="space-y-6 bg-white p-6 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold">
        Select Category & Outlet
      </h2>

      {/* ======================
          CATEGORY SELECT
      ====================== */}
      <div>
        <label className="block mb-2">Category</label>
        <Select
          options={categoryOptions}
          isLoading={categoryLoading}
          onChange={(option: any) => {
            setSelectedCategory(option?.value || "");
          }}
        />
      </div>

      {/* ======================
          OUTLET MULTI SELECT
      ====================== */}
      <div>
        <label className="block mb-2">Outlets</label>
        <Select
          isMulti
          options={partnerOptions}
          isLoading={partnersLoading}
          isDisabled={!selectedCategory}
          placeholder={
            !selectedCategory
              ? "Select category first"
              : "Select outlets"
          }
          onChange={handleOutletChange} 
        />
      </div>
    </div>
  );
};

export default CentralPartnerBasicInfoForm;